import React, {useEffect, useState} from "react";
import {
    RegisterPageWrapper,
    BackgroundImage,
    FormWrapper,
    GalilLogo,
    AlreadyHaveAccount,
    Title,
    FormInnerWrapper, ErrorMessage,
    FormContainer,
    TextContainer,
    LoaderOverlay
} from "./styles";
import Loader from "../../components/loader/Loader";
import backgroundImage from '../../resources/images/login-banner.webp'
import logo from '../../resources/images/galil-logo.svg'
import {NavLink, useNavigate} from "react-router-dom";
import Input from "../../components/common/input/Input";
import Button from "../../components/common/button/Button";
import {useDispatch, useSelector} from "react-redux";
import {selectIsLoading, selectIsLoggedIn, selectRegisterSuccess} from "../../store/user/selectors";
import {userActions} from "../../store/user";
import {alertsActions} from "../../store/alerts";
import {useTranslation} from "react-i18next";

const RegisterPage: React.FC = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [company, setCompany] = useState('');
    const isLoading = useSelector(selectIsLoading);
    const isRegistered = useSelector(selectRegisterSuccess);
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {t} = useTranslation();

    useEffect(() => {
        if(isLoggedIn) {
            navigate('/', {replace: true});
        }
    }, [isLoggedIn, navigate]);

    const onSubmit = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if(!isLoading && name.length > 0 && email.length > 0 && phone.length > 0) {
            const page_url = window.location.href;
            dispatch(userActions.register({email, name, phone, company, page_url}));
        }
    }

    useEffect(() => {
        if(isRegistered) {
            dispatch(userActions.registerClear());
            
            // Check if user is on mobile device based on window width
            const isMobile = window.innerWidth <= 768;
            
            if (isMobile) {
                // Mobile users: navigate to success page
                navigate('/register-success', {replace: true});
            } else {
                // Desktop users: navigate to login with toast
                navigate('/login', {replace: true});
                dispatch(alertsActions.enqueue({sevirity: 'success', text: t('REGISTRATION_SUCCESS_MESSAGE'), duration: 30000}))
            }
        }
    }, [isRegistered, navigate, dispatch, t])

    return (
    <RegisterPageWrapper key="register-form-wrapper">
        {(isLoading) && (
            <LoaderOverlay>
                <Loader show={true} />
            </LoaderOverlay>
        )}
        <BackgroundImage src={backgroundImage} />
        <FormWrapper key="register-form">
            <TextContainer>
                    <h1>BillBot.AI - מערכת לקליטת חשבוניות באחוזי דיוק גבוהים וללא צורך באימון הבינה המלאכותית</h1>

                    <p style={{'fontSize': '1.2em'}}>
                    שירות Document Understanding ענני מבוסס AI לחילוץ מושלם של מידע מתוך מסמכי PDF מקוריים וסרוקים.<br/>
                    <span style={{'fontWeight' : 'bold'}}>
                    מותאם לחלץ טקסט מחשבוניות, הזמנות, תעודות משלוח וקבלות באחוזי דיוק גבוהים וללא צורך באימון הבינה המלאכותית.

                    </span><br/>
                    </p>

                    <p style={{'fontSize': '1.2em'}}>
                    העלו את החשבוניות שלכם לסביבת ההתנסות שלנו ותראו איך המערכת סורקת, מחלצת ומארגנת את הנתונים בלחיצת כפתור.
                    </p>


                    {/* <h2>התאמה מלאה למערכות הארגון</h2>

                    <p>
                    השירות מאפשר לטעון את הטקסט המחולץ למערכות המחשוב הארגוניות, באוטומציה קצה לקצה ללא מגע יד אדם.
                    הטעינה מבוססת על ממשקים ייעודיים וכלי אוטומציה בהתאם למערכות העבודה של הארגון וללא צורך באימון הבינה המלאכותית.
                    </p>

                    <ul>
                    <li>
                        <strong>ללא צורך באימון AI</strong>
                        טיפול בחשבוניות ללא אימון הבינה המלאכותית
                    </li>
                    <li>
                        <strong>דיוק</strong>
                        95% דיוק ויכולת מתקדמת לזיהוי שגיאות
                    </li>
                    <li>
                        <strong>Dataless</strong>
                        שמירה על פרטיות – המידע נשמר רק אצלכם!
                    </li>
                    <li>
                        <strong>הספק</strong>
                        חילוץ טקסט דיגיטלי 24/7
                    </li>
                    <li>
                        <strong>החזר השקעה מהיר</strong>
                        עלות נמוכה מהקלדה ידנית
                    </li>
                    <li>
                        <strong>חיסכון בכוח אדם</strong>
                    </li>
                    <li>
                        <strong>מעקב ובקרה</strong>
                        דוחות שימוש ומידע סטטיסטי ללקוח
                    </li>
                    </ul> */}

                    <h2>הירשמו ונסו עכשיו!</h2>

            </TextContainer>
            <FormContainer style={{position: 'relative'}}>
                <GalilLogo src={logo} />
                <FormInnerWrapper key="register-form-inner-wrapper" onSubmit={onSubmit}>
                    <Title>{t('FULL_NAME')}</Title>
                    <Input key="register-form-name-input" textAlign="right" value={name} onChange={e => setName(e.target.value)} />
                    <Title>{t('EMAIL')}</Title>
                    <Input key="register-form-mail-input" value={email} onChange={e => setEmail(e.target.value)} />
                    <Title>{t('PHONE_NUMBER')}</Title>
                    <Input key="register-form-phone-input" value={phone} onChange={e => setPhone(e.target.value)} />
                    <Title>{t('COMPANY')}</Title>
                    <Input key="register-form-company-input" textAlign="right" value={company} onChange={e => setCompany(e.target.value)} />
                    <Button
                        key="register-form-submit-button"
                        label={t('I_WANT_TO_JOIN')}
                        type="submit"
                        disabled={isLoading || name.length === 0 || email.length === 0 || phone.length === 0 || company.length === 0}
                    />
                    {isRegistered === false && <ErrorMessage>{t('REGISTRATION_ERROR')}</ErrorMessage>}
                </FormInnerWrapper>
                <NavLink to="/login">
                    <AlreadyHaveAccount key="register-form-login-button">
                        {t('ALREADY_REGISTERED')}
                    </AlreadyHaveAccount>
                </NavLink>
            </FormContainer>
        </FormWrapper>
    </RegisterPageWrapper>)
}

export default RegisterPage;
